import { getAppointmentDocumentId } from "../services/appointmentService";

export const getSelectableAppointmentIds = (appointments = []) =>
  appointments
    .map(getAppointmentDocumentId)
    .filter(Boolean);

export const getAppointmentSelectionLabel = (count) => {
  const normalizedCount = Math.max(0, Number(count) || 0);

  if (!normalizedCount) return "";

  return normalizedCount === 1 ? "1 selectată" : `${normalizedCount} selectate`;
};

export const toggleAppointmentSelection = (selection, appointmentId) => {
  const nextSelection = new Set(selection || []);
  const normalizedId = String(appointmentId || "").trim();

  if (!normalizedId) return nextSelection;

  if (nextSelection.has(normalizedId)) {
    nextSelection.delete(normalizedId);
  } else {
    nextSelection.add(normalizedId);
  }

  return nextSelection;
};

export const toggleAllAppointmentSelection = (selection, appointments = []) => {
  const nextSelection = new Set(selection || []);
  const appointmentIds = getSelectableAppointmentIds(appointments);
  const allSelected = appointmentIds.length > 0
    && appointmentIds.every((appointmentId) => nextSelection.has(appointmentId));

  appointmentIds.forEach((appointmentId) => {
    if (allSelected) {
      nextSelection.delete(appointmentId);
    } else {
      nextSelection.add(appointmentId);
    }
  });

  return nextSelection;
};
